const UPDATE_RESTAURANT_SETTINGS_SUCCESS_TEXT = "Les paramètres du restaurant ont été modifiés.";
const UPDATE_EMAIL_SETTINGS_SUCCESS_TEXT = "Les paramètres de notification par e-mail ont été modifiés.";

export const UPDATE_RESTAURANT_SETTINGS_SUCCESS = UPDATE_RESTAURANT_SETTINGS_SUCCESS_TEXT;
export const UPDATE_EMAIL_SETTINGS_SUCCESS = UPDATE_EMAIL_SETTINGS_SUCCESS_TEXT;


const ADD_OPENING_HOUR_SUCCESS_TEXT = "L'horaire a été ajouté.";
const DELETE_OPENING_HOUR_SUCCESS_TEXT = "L'horaire a été supprimé.";
const UPDATE_OPENING_HOUR_SUCCESS_TEXT = "L'horaire a été modifié.";

export const ADD_OPENING_HOUR_SUCCESS = ADD_OPENING_HOUR_SUCCESS_TEXT;
export const DELETE_OPENING_HOUR_SUCCESS = DELETE_OPENING_HOUR_SUCCESS_TEXT;
export const UPDATE_OPENING_HOUR_SUCCESS = UPDATE_OPENING_HOUR_SUCCESS_TEXT;


const ADD_CUSTOM_EVENT_SUCCESS_TEXT = "L'option personnalisée a été ajoutée.";
const DELETE_CUSTOM_EVENT_SUCCESS_TEXT = "L'option personnalisée a été supprimée.";
const UPDATE_CUSTOM_EVENT_SUCCESS_TEXT = "L'option personnalisée a été modifiée.";

export const ADD_CUSTOM_EVENT_SUCCESS = ADD_CUSTOM_EVENT_SUCCESS_TEXT;
export const DELETE_CUSTOM_EVENT_SUCCESS = DELETE_CUSTOM_EVENT_SUCCESS_TEXT;
export const UPDATE_CUSTOM_EVENT_SUCCESS = UPDATE_CUSTOM_EVENT_SUCCESS_TEXT;

export const ADD_MESSAGE_SAMPLE_SUCCESS = "Le message-type a été ajouté.";
export const UPDATE_MESSAGE_SAMPLE_SUCCESS = "Le message-type a été modifié.";
export const DELETE_MESSAGE_SAMPLE_SUCCESS = "Le message-type a été supprimé.";

export const ADD_RESERVATION_CONDITION_SUCCESS = "La condition a été ajoutée.";
export const UPDATE_RESERVATION_CONDITION_SUCCESS = "La condition a été modifiée.";
export const DELETE_RESERVATION_CONDITION_SUCCESS = "La condition a été supprimée.";

export const ADD_SPECIAL_OPTION_CATEGORY_SUCCESS = "La catégorie a été ajoutée.";
export const UPDATE_SPECIAL_OPTION_CATEGORY_SUCCESS = "La catégorie a été modifiée.";
export const DELETE_SPECIAL_OPTION_CATEGORY_SUCCESS = "La catégorie a été supprimée.";

export const ADD_SPECIAL_OPTION_SUCCESS = "L'option a été ajoutée.";
export const UPDATE_SPECIAL_OPTION_SUCCESS = "L'option a été modifiée.";
export const DELETE_SPECIAL_OPTION_SUCCESS = "L'option a été supprimée.";




// WEBPACK FOOTER //
// ./src/successes/settings.js